import * as XLSX from "xlsx";

function normalizeExcelDate(value) {
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const year = value.getFullYear();
    const month = String(value.getMonth() + 1).padStart(2, "0");
    const day = String(value.getDate()).padStart(2, "0");
    return `${year}/${month}/${day}`;
  }

  if (typeof value === "number") {
    const decoded = XLSX.SSF.parse_date_code(value);
    if (decoded) {
      return `${decoded.y}/${String(decoded.m).padStart(2, "0")}/${String(decoded.d).padStart(2, "0")}`;
    }
  }

  return value;
}

export function parseUploadedRows(fileData) {
  const wb = XLSX.read(fileData, {
    type: "array",
    cellDates: true,
    cellNF: true,
  });
  const ws = wb.Sheets[wb.SheetNames[0]];
  if (!ws) return [];

  const rows = XLSX.utils.sheet_to_json(ws, {
    defval: "",
    raw: false,
    dateNF: "yyyy/mm/dd",
  });
  const rawRows = XLSX.utils.sheet_to_json(ws, { defval: "", raw: true });

  rows.forEach((row, index) => {
    for (const dateField of ["Birth Date", "Employment Date", "Termination Date"]) {
      const rawValue = rawRows[index]?.[dateField];
      if (rawValue instanceof Date || typeof rawValue === "number") {
        row[dateField] = normalizeExcelDate(rawValue);
      }
    }
  });

  return rows;
}
